// Nearby parking lots for the CODE contact modal (Figma node 8307:10166).
// `query` is locale-agnostic and used only for the Google Maps embed.
export const NEARBY_PARKINGS = [
  { id: 'fabryczna_underground', query: 'Parking Podziemny Dworzec Łódź Fabryczna, 90-001 Łódź' },
  { id: 'ec1', query: 'Parking EC-1, Dowborczyków 7, Łódź' },
  { id: 'fabryczna', query: 'Parking Fabryczna, Łódź' },
  { id: 'wschodnia', query: 'Parking wielopoziomowy, Wschodnia 62/64, Łódź' },
  { id: 'sienkiewicza_11', query: 'Parking, Henryka Sienkiewicza 11, Łódź' },
  { id: 'off_s1', query: 'OFF Parking S1, Henryka Sienkiewicza 81, Łódź' },
];
